import React, { Component } from 'react'
import { connect } from 'react-redux'
import appConfig from '../../config/app'

import { vkShare, fbShare, okShare } from '../../actions/ShareActions'

import { getText } from '../../actions/ContentActions'

import ShareButton from './ShareButton'

class Share extends Component {
	static defaultProps = {
		card: {},
		text: {}
	}

	componentWillMount() {
		let localPostcard = JSON.parse(localStorage.getItem('postcard'))
		var textId = parseInt(this.props.card.text_id, 10)

		var metaOg = document.getElementById('ogImg')
		var metaOgUrl = document.getElementById('ogImgUrl')
		metaOg.content = `${appConfig.basePath}${this.props.card.origin_image}`
		metaOgUrl.content = `${appConfig.basePath}${this.props.card.origin_image}`

		this.props.dispatch(getText(textId))
	}

	handleShare = (component, event) => {
		console.log(this.props.texts)
		var url = `${appConfig.basePath}postcard/${this.props.card.short_link}`
		var title = 'Открытка из Кузбасса'
		var img = `${appConfig.basePath}${this.props.card.origin_image}`
		var text = ''

		switch(component.props.socialTag) {
			case 'ok':
				text = this.props.text.value
			break;
			case 'vk':
				text = 'Создай свое Новогоднее поздравление'
			break;
			case 'fb':
				text = 'Создай свое Новогоднее поздравление'
			break;
			default:
			break;
		}

		this.props.dispatch(component.props.shareAction(url, title, text, img));
	}

	render() {
		return(
			<div className="social-sharing">
				<ShareButton 
					className="vkontakte"
					socialTag="vk" 
					shareAction={vkShare} 
					onClick={this.handleShare} />

				<ShareButton 
					className="facebook"
					socialTag="fb"
					shareAction={fbShare} 
					onClick={this.handleShare} />

				<ShareButton 
					className="odnoklassniki"
					socialTag="ok" 
					shareAction={okShare} 
					onClick={this.handleShare} />
			</div>
		)
	}
}

export default connect((state) => ({
	text: state.text.data
}))(Share)


// WEBPACK FOOTER //
// ./src/components/share/Share.js